/* eslint-disable import/no-anonymous-default-export */
export default {
  name: "اسم المستخدم",
  role: "تعيين",
  status: "حالة",
  leaveDur: "مدة الإجازة",
  from: "من تاريخ",
  to: "حتى الآن",
  date: "تاريخ",
  requestedDate: "طلب على",
  selectallRequest: "حدد كل الطلب",
  myLeave: "طلبات إجازتي",
  leaveReason: "اترك السبب",
  disapproveReason: "سبب مرفوض",
  reasonTitle: "أضف سببًا",
  reasonplaceholder: "يضيف",
  disapproveTaskAlert: "هل أنت متأكد أنك تريد رفض هذا الطلب؟",
  approveTaskAlert: "هل أنت متأكد أنك تريد الموافقة على هذا الطلب؟",
  addReason: "أضف سببًا",
  toDateError: 'يجب أن يكون تاريخ "حتى الآن" أكبر من تاريخ "من"',
};
